import HttpRequest from "../services/HttpRequest";

export function initGlobalErrorHandlers() {
  window.onerror = function (message, source, lineno, colno, error) {
    const errorPath = window.location?.pathname || 'unknown';
    const errorDescription = `${message} at ${source}:${lineno}:${colno}`;

    HttpRequest.request({
      url: '/error/log',
      method: 'post',
      data: { errorPath, errorDescription },
    }).catch(err => console.error("Global onerror logging failed:", err));
  };

  window.onunhandledrejection = function (event) {
    const reason = event.reason;
    const description = reason instanceof Error ? reason.stack : JSON.stringify(reason);
    const errorPath = window.location?.pathname || 'unknown';

    HttpRequest.request({
      url: '/error/log',
      method: 'post',
      data: { errorPath, errorDescription: `Unhandled rejection: ${description}` },
    }).catch(err => console.error("Global unhandledrejection logging failed:", err));
  };
}
